import { useDispatch } from 'react-redux'
import { closeSidePanelPopOver } from '../../dux/ui/actions'

export function useCloseSidePanelPopOver(){
  const dispatch = useDispatch()
  return () => dispatch(closeSidePanelPopOver())
}